import {makeAdultsCounter, makeChildsCounter} from '../actions/utils'

const getSearch = function (state) {
  if (state.search.camere) {
    const camere = JSON.parse(JSON.stringify(state.search.camere))
    return {...state.search, camere}
  }
  return {...state.search}
}
const getAdultsCounter = function (state) {
  return makeAdultsCounter(state)
}
const getChildsCounter = function (state) {
  return makeChildsCounter(state)
}

export default {
  getSearch,
  getAdultsCounter,
  getChildsCounter
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/search.js